<script>
import Base from '@/plans/ZOOM_WHITEBOARD/config/base';

export default {
  extends: Base
};
</script>
